module.exports = __webpack_public_path__ + "img/ring_y_0_1_0@2x.4eb8358e.png";